import React from 'react';
import property_contents_2 from '../images/property-contents-2.jpg'
import property_contents_1 from '../images/property-contents-1.jpg'
import property_contents_4 from '../images/property-contents-4.jpg'
import property_contents_3 from '../images/property-contents-3.jpg'
import './Property.css'
import GroupTitle, {GroupTitileOrange, GroupTitleBackground, GroupTitleText} from "./GroupTitle";
import PictureShow from "../pictureShow/PictureShow";
import {PSIPictureItem} from "../pictureShow/PictureShowItem";

export default function Property(){
   return(
        <div className='property'>
            <GroupTitle>
                <GroupTitleBackground>Property</GroupTitleBackground>
                <GroupTitleText>
                    <span>知识</span>
                    <GroupTitileOrange>产权</GroupTitileOrange>
                </GroupTitleText>
            </GroupTitle>
            <PictureShow className="qualification-picture-show">
                <PSIPictureItem src={property_contents_3}/>
                <PSIPictureItem src={property_contents_4}/>
                <PSIPictureItem src={property_contents_1}/>
                <PSIPictureItem src={property_contents_2}/>
            </PictureShow>
        </div>
   )
}